





















import Vue from 'vue'
import CreateDialog from './CreateDialog.vue'
export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    onReject() {
      this.loading = true
      this.$emit('done', false)
      this.$emit('input', false)
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    onSuccess() {
      this.loading = true
      this.$emit('done', true)
      this.$emit('input', false)
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    onInput(payload: boolean) {
      if (!payload) {
        this.onReject()
      } else this.$emit('input', payload)
    },
  },
})
